import { FC } from 'react';
import { AiGenerateButton } from 'src/components/widgets/ai';
import { useAgentAssistant } from 'src/components/widgets/agentAssistant';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';

const HandoffAction = styled.div`
    margin-top: 12px;
`;

interface AiUtilityHandoffProps {
    prompt: string | null | undefined;
    onClose: () => void;
}

export const AiUtilityHandoff: FC<AiUtilityHandoffProps> = ({ prompt, onClose }) => {
    const { isEnabled, startWithPrompt } = useAgentAssistant();
    if (!isEnabled || !prompt?.trim()) return null;

    return (
        <HandoffAction>
            <AiGenerateButton
                type='button'
                onClick={() => {
                    onClose();
                    startWithPrompt(prompt.trim());
                }}
            >
                {T._('Open Zakeke AI', 'Admin')}
            </AiGenerateButton>
        </HandoffAction>
    );
};
